import './index.less';
import "mkui-fd/es/tag/style";
//# sourceMappingURL=index.js.map
